export enum GlobalPriceType {
    Percentage = "Percentage",
    Value = "Value"
}